import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Image',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Image',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Image',
    column_type: 'datetime',
  },
  title: {
    model_name: 'Image',
    column_type: 'string',
  },
  fail_message: {
    model_name: 'Image',
    column_type: 'string',
  },
  task_id: {
    model_name: 'Image',
    column_type: 'string',
  },
  state: {
    model_name: 'Image',
    column_type: 'enum',
  },
  user: {
    model_name: 'Image',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  user_id: {
    model_name: 'Image',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  raw: {
    model_name: 'Image',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  origin: {
    model_name: 'Image',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  results: {
    model_name: 'Image',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  options: {
    model_name: 'Image',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
